export default __webpack_public_path__ + "static/media/PaintingPenArtSchool-1.c98ca72f.jpg";